// extracted by mini-css-extract-plugin
export default {"title":"RecurringPayments_title__wXPc9","input":"RecurringPayments_input__gRDuh"};